{
  "modal": {
    "loading": "Cargando…",
    "share": "Copiar enlace de la tarea",
    "description": "Descripción",
    "description_placeholder": "Agrega una descripción…",
    "link": "Enlace",
    "link_placeholder": "https://… (video, documento, etc.)",
    "attachments": "Adjuntos",
    "subtasks": "Subtareas",
    "subtask_add": "Añadir",
    "subtask_add_full": "Añadir subtarea",
    "subtask_placeholder": "Nombre de la subtarea (Esc para cancelar)",
    "subtask_open_title": "Abrir subtarea",
    "subtask_assign": "Asignar responsable",
    "delete_title": "Eliminar",
    "activity": "Actividad ({n})",
    "activity_empty": "Aún no hay comentarios. Sé el primero en escribir.",
    "loading_older": "Cargando mensajes anteriores…",
    "conversation_start": "Inicio de la conversación",
    "comment_delete": "Eliminar",
    "comment_placeholder": "Escribe un comentario… (escribe {'@'} para mencionar)",
    "attach_file": "Adjuntar archivo",
    "send": "Enviar",
    "properties": "Propiedades",
    "projects": "Proyectos",
    "project_principal": "principal",
    "project_add_title": "Añadir a otro proyecto",
    "project_remove_title": "Quitar de este proyecto",
    "assignee": "Responsable",
    "collaborators": "Colaboradores",
    "unassigned": "Sin asignar",
    "assign_me": "Asignarme a mí",
    "assign_to": "Asignar responsable",
    "add_collaborator": "Añadir colaborador",
    "remove_collaborator": "Quitar colaborador",
    "search_member": "Buscar miembro…",
    "no_members": "Sin resultados",
    "tracking": "Seguimiento",
    "start_task": "Iniciar tarea",
    "pause_task": "Pausar",
    "resume_task": "Reanudar",
    "complete_task": "Completar",
    "running": "En curso",
    "paused": "En pausa",
    "created_at": "Creada",
    "started_at": "Iniciada",
    "completed_at": "Completada",
    "duration": "Tiempo activo",
    "due_date": "Fecha límite",
    "priority": "Prioridad",
    "recurrence": "Repetir",
    "recurrence_none": "No se repite",
    "recurrence_daily": "Cada día",
    "recurrence_weekly": "Cada semana",
    "recurrence_monthly": "Cada mes",
    "recurrence_yearly": "Cada año",
    "recurrence_custom": "Personalizado…",
    "recurrence_every": "Cada",
    "recurrence_until": "Hasta",
    "recurrence_warning_no_date": "Agrega una fecha límite para definir cuándo se repite.",
    "uploading": "Subiendo…",
    "delete_task": "Eliminar tarea",
    "channel_connect_failed": "No se pudo conectar al canal de la tarea:",
    "size": "Tamaño",
    "size_none": "Sin estimar",
    "deps_blocked_by": "Bloqueada por",
    "deps_blocks": "Bloquea a",
    "deps_add": "Agregar",
    "deps_add_full": "Agregar dependencia",
    "deps_search": "Buscar tarea…",
    "deps_empty": "Sin resultados",
    "deps_remove": "Quitar dependencia",
    "deps_blocked_badge": "Bloqueada por {n} tarea | Bloqueada por {n} tareas",
    "overdue": "Vencida",
    "requester": "Solicitante",
    "requester_none": "Sin solicitante",
    "requester_name_placeholder": "Nombre de quien lo pidió",
    "requester_email_placeholder": "Correo (opcional)",
    "requester_edit_title": "Editar solicitante",
    "requester_save": "Guardar",
    "requester_cancel": "Cancelar",
    "requester_external": "Ticket del portal público"
  },
  "freq": {
    "day_one": "día",
    "day_other": "días",
    "week_one": "semana",
    "week_other": "semanas",
    "month_one": "mes",
    "month_other": "meses",
    "year_one": "año",
    "year_other": "años"
  },
  "recurrence_label": {
    "every_one": "Cada {word}",
    "every_n": "Cada {n} {word}",
    "until_suffix": " hasta {date}"
  },
  "time": {
    "today": "Hoy {time}",
    "yesterday": "Ayer {time}",
    "date_time": "{date} {time}"
  },
  "priority": {
    "low": "Baja",
    "medium": "Media",
    "high": "Alta",
    "urgent": "Urgente"
  },
  "confirm": {
    "delete_subtask_title": "¿Eliminar esta subtarea?",
    "delete_subtask_message": "Se borrará junto con sus comentarios y adjuntos.",
    "delete_attachment_title": "¿Eliminar este adjunto?",
    "delete_attachment_message": "El archivo se borrará de forma permanente.",
    "delete_comment_title": "¿Eliminar este comentario?",
    "delete_comment_message": "Se eliminará junto con sus adjuntos.",
    "delete_task_title": "¿Eliminar esta tarea?",
    "delete_task_message": "Se perderán sus comentarios, adjuntos y subtareas.",
    "delete_task_action": "Eliminar tarea"
  },
  "board": {
    "rename": "Renombrar",
    "reset_name": "Restablecer nombre",
    "rename_task_title": "Editar el nombre",
    "delete": "Eliminar",
    "min_one_column_title": "Debe quedar al menos una columna",
    "delete_column_title": "Eliminar columna",
    "mark_pending": "Marcar como pendiente",
    "mark_done": "Marcar como completada",
    "attachments_title": "Adjuntos",
    "comments_title": "Comentarios",
    "task_placeholder": "Nombre de la tarea",
    "add_task": "Agregar tarea",
    "add": "Agregar",
    "cancel": "Cancelar",
    "create": "Crear",
    "add_column": "Añadir columna",
    "column_placeholder": "Nombre de la columna",
    "completed_count": "Sin completadas | {n} completada | {n} completadas",
    "load_more": "Cargar más",
    "loading": "Cargando…",
    "drag_column_title": "Arrastra para reordenar la columna",
    "age_title": "Tiempo desde que se creó",
    "completed_in_title": "Tiempo que tardó en completarse",
    "completed_in": "Completada en {duration}",
    "duration_under_minute": "menos de 1 min",
    "status_title": "Estado actual en el tablero",
    "size_title": "Tamaño estimado (talla)",
    "column_menu_title": "Opciones de la columna",
    "view_list": "Lista",
    "view_board": "Tablero",
    "view_calendar": "Calendario",
    "view_timeline": "Cronograma",
    "subtasks_title": "Subtareas",
    "subtasks_show": "Mostrar subtareas",
    "subtasks_hide": "Ocultar subtareas",
    "subtasks_progress_title": "{done} de {total} subtareas completadas",
    "unassigned": "Sin asignar",
    "unassigned_title": "Esta tarea no tiene responsable",
    "requested_by": "Solicitó: {name}",
    "requested_by_title": "Solicitante"
  },
  "list": {
    "personal_no_project": "Personal · sin proyecto",
    "empty": "Sin tareas para mostrar"
  },
  "calendar": {
    "weekdays": [
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb",
      "Dom"
    ],
    "month_prev": "Mes anterior",
    "month_next": "Mes siguiente",
    "today": "Hoy",
    "more_count": "+{n} más"
  },
  "timeline": {
    "zoom_day": "Día",
    "zoom_week": "Semana",
    "zoom_month": "Mes",
    "task_header": "Tarea",
    "unscheduled": "Sin programar",
    "summary": "{n} tareas programadas · {m} sin fecha",
    "dow_labels": [
      "D",
      "L",
      "M",
      "X",
      "J",
      "V",
      "S"
    ],
    "empty": "Aún no hay tareas con fecha. Asigna una fecha límite para verla aquí."
  },
  "time_tracker": {
    "title": "Tiempo",
    "start": "Iniciar",
    "start_title": "Iniciar timer",
    "stop_title": "Detener · {time}",
    "manual": "Manual",
    "add_manual_title": "Añadir tiempo manualmente",
    "notes_placeholder": "Notas (opcional)",
    "cancel": "Cancelar",
    "add": "Añadir",
    "running": "Corriendo",
    "delete_title": "Eliminar",
    "empty": "Aún no hay tiempo registrado.",
    "confirm_delete_title": "¿Eliminar este registro de tiempo?",
    "confirm_delete_message": "Se borrarán {duration} del historial.",
    "confirm_delete_action": "Eliminar"
  },
  "attachment": {
    "compact_attach": "📎 Adjuntar archivo",
    "drop_or_click": "Arrastra archivos aquí o haz clic para seleccionar",
    "file_types": "Imágenes, video, PDF, docs",
    "remove": "Quitar"
  },
  "link": {
    "loading": "Abriendo la tarea…",
    "not_found": "Esta tarea ya no existe o no tienes acceso a ella.",
    "error": "No se pudo abrir la tarea. Intenta de nuevo.",
    "go_to_my_tasks": "Ir a mis tareas"
  }
}
